import { type RevisionPage, RevisionPageType } from '../types';
import { normalizePageTitle } from './utils';

/**
 * Duplicates a revision page based on its kind.
 *
 * Will not duplicate sub pages or other references.
 */
export function duplicatePage(
    original: RevisionPage,
    args: {
        pageId: string;
        /** If true, page will be renamed to Copy of OLD_TITLE. Defaults to false */
        rename?: boolean;
    }
): RevisionPage {
    const { pageId, rename = false } = args;
    return {
        ...structuredClone(original),
        id: pageId,
        title: rename ? normalizePageTitle(`Copy of ${original.title}`) : original.title,
        git: undefined,
        // @ts-ignore - Link page types don't have pages
        pages: original.type === RevisionPageType.Link ? undefined : [],
    };
}
